<div class="content-container flex items-center justify-center">
  <div class="content-card flex items-center justify-between flex-col h-full">
    <div class="flex justify-center py-6">
        <app-svg [name]="brandFullLogo" [color]="ss.theme().color1"></app-svg>
    </div>
    <div class="flex justify-center py-6 flex-col">
      <img class="w-auto hero-img" src="assets/imgs/deleted.svg" [attr.alt]="brandName">
      <h5 class="text-20-500 text-center color-8 text-info">{{ ss.t('accountDeletedGoodBye_title') }}</h5>
      <p class="text-16-400 text-center color-7 ri-pt-4">{{ ss.t('accountDeletedGoodBye_content') }}</p>
    </div>

    <button class="btn w-full text-center btn-login" (click)="goToLogin()">
      <span class="text-14-500 color-12">{{ ss.t('accountDeletedGoodBye_goToLogin') }}</span>
    </button>
  </div>
</div>